// import KidneyMedicinesCard from "./KidneyMedicinesCard"; // Adjust the import path as necessary
// import { useNavigate } from 'react-router-dom';



// const KidneyMedicines = ({ products, globalConfig, stepperProgressCartData, setStepperProgressCartData, refreshProducts }) => {
//   const navigate = useNavigate()

//   return (
//     <div className='my-8 w-full'>
//       <div className=' font-bold text-2xl'>Kidney Medicines</div>
//       <div>
//         <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-1'>
//           {
//             products?.map((item) => (
//               <KidneyMedicinesCard item={item} globalConfig={globalConfig} stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} refreshProducts={refreshProducts}/>
//             )
//             )
//           }
//         </div>
//         <div className='flex w-full items-center justify-center'>
//           <button onClick={() => navigate("/products")} className="mt-4 bg-[#14967F] hover:text-white px-7 py-2 rounded-full transition duration-300 transform hover:scale-105">
//             <span className=" font-semibold text-xs">Load more</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// };

// export default KidneyMedicines;

import React from "react";
import { useNavigate } from "react-router-dom";
import KidneyMedicinesCard from "./KidneyMedicinesCard"; // Adjust path as needed

const KidneyMedicines = ({
  products,
  globalConfig,
  stepperProgressCartData,
  setStepperProgressCartData,
  refreshProducts
}) => {
  const navigate = useNavigate();

  return (
    <div className="my-8 w-full">
      <div className="font-bold text-2xl mb-4">Kidney Medicines</div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
        {products?.map((item) => (
          <KidneyMedicinesCard
            key={item._id} // 🔹 Must have unique key
            item={item}
            globalConfig={globalConfig}
            stepperProgressCartData={stepperProgressCartData}
            setStepperProgressCartData={setStepperProgressCartData}
            refreshProducts={refreshProducts} // 🔹 MUST pass trigger from Home
          />
        ))}
      </div>

      <div className="flex w-full items-center justify-center mt-4">
        <button
          onClick={() => navigate("/products")}
          className="bg-[#14967F] hover:text-white px-7 py-2 rounded-full transition duration-300 transform hover:scale-105"
        >
          <span className="font-semibold text-xs">Load more</span>
        </button>
      </div>
    </div>
  );
};

export default KidneyMedicines;